import { render } from "./message-rich-text.vue?vue&type=template&id=17ccdf47&ts=true"
import script from "./message-rich-text.vue?vue&type=script&lang=ts"
export * from "./message-rich-text.vue?vue&type=script&lang=ts"

import "./message-rich-text.vue?vue&type=style&index=0&id=17ccdf47&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__